import _defineProperty from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormSyncErrors, getFormValues, touch } from 'redux-form';
import PropTypes from 'prop-types';
import _set from 'lodash/set';
import BirFormStep from './components/BirFormStep/BirFormStep';
import ToastService from '../../services/Toast';
import { getSectionConditionsInfo } from './utils/condition/selectors';
import { filterFieldsByFieldIds } from './utils/fieldId';
var FORM_NAME = 'birForm';

var BirForm =
/*#__PURE__*/
function (_Component) {
  _inherits(BirForm, _Component);

  function BirForm() {
    var _getPrototypeOf2;

    var _this2;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, BirForm);

    var _temp, _this;

    return _possibleConstructorReturn(_this2, (_temp = _this = _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BirForm)).call.apply(_getPrototypeOf2, [this].concat(args))), _this2.state = {
      currentStep: 1,
      biggestStepReached: 1,
      stepErrors: {},
      formValidationInProgress: false
    }, _this2.getCleanFormData = function () {
      var formData = _this2.props.formData;

      var cleanFormData = _extends({}, formData);

      Object.keys(cleanFormData).filter(function (key) {
        return key.match(/\.|\[/);
      }).forEach(function (key) {
        _set(cleanFormData, key, cleanFormData[key]);

        delete cleanFormData[key];
      });
      return cleanFormData;
    }, _this2.componentDidMount = function () {
      var currentStep = _this2.getCurrentStepNumber();

      _this2.setState({
        currentStep: currentStep,
        biggestStepReached: currentStep
      }, function () {
        return _this2.validatePreviousSteps(currentStep);
      }); // on initial load, validate form up to current step

    }, _this2.getTotalSteps = function () {
      var filteredFieldsHierarchy = _this2.props.filteredFieldsHierarchy;
      return filteredFieldsHierarchy.length;
    }, _this2.getCurrentStepNumber = function () {
      var _this2$props = _this2.props,
          currentStepTitle = _this2$props.currentStepTitle,
          filteredFieldsHierarchy = _this2$props.filteredFieldsHierarchy;
      var step = filteredFieldsHierarchy.find(function (s) {
        return s.title === currentStepTitle;
      });
      return step && step.stepNumber || 1;
    }, _this2.getStepTitles = function () {
      var filteredFieldsHierarchy = _this2.props.filteredFieldsHierarchy;
      return filteredFieldsHierarchy.map(function (step) {
        return step.title;
      });
    }, _this2.handleStepSubmit = function () {
      var onStepSubmit = _this2.props.onStepSubmit;
      var currentStep = _this2.state.currentStep;

      var stepNames = _this2.getStepTitles();

      var formData = _this2.getCleanFormData();

      onStepSubmit(formData, stepNames[currentStep - 1]);
    }, _this2.handleFinalSubmit = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this$state, totalSteps, currentStep, stepErrors, _this$props, handleFinalSubmit, dispatchTouch, formData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, totalSteps = _this$state.totalSteps, currentStep = _this$state.currentStep, stepErrors = _this$state.stepErrors;
              _this$props = _this.props, handleFinalSubmit = _this$props.handleFinalSubmit, dispatchTouch = _this$props.dispatchTouch;
              _context.next = 4;
              return _this.validatePreviousSteps(totalSteps);

            case 4:
              if (!_this.isFormValid()) {
                _context.next = 7;
                break;
              }

              formData = _this.getCleanFormData();
              return _context.abrupt("return", handleFinalSubmit(formData));

            case 7:
              ToastService.showWarning('Please fill all the required fields and try again.'); // touch the fields, that causes validation errors to be shown

              if (_this.isCurrentStepValid()) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", dispatchTouch.apply(void 0, [FORM_NAME].concat(_toConsumableArray(stepErrors[currentStep]))));

            case 10:
              _this.jumpToStep(_this.getLowestInvalidStep());

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this2.getInvalidFieldsForCurrentStep = function () {
      var formSyncErrors = _this2.props.formSyncErrors;
      return _this2.getKeypathList(formSyncErrors);
    }, _this2.isCurrentStepValid = function () {
      return _this2.getInvalidFieldsForCurrentStep().length === 0;
    }, _this2.isFormValid = function () {
      var stepErrors = _this2.state.stepErrors;
      return !Object.keys(stepErrors).filter(function (key) {
        return !!stepErrors[key];
      }).length;
    }, _this2.getLowestInvalidStep = function () {
      var _this2$state = _this2.state,
          stepErrors = _this2$state.stepErrors,
          currentStep = _this2$state.currentStep;
      var stepNumber = Object.keys(stepErrors).reduce(function (lowestStepNumber, stepNumber) {
        return stepErrors[stepNumber] && stepNumber < lowestStepNumber ? stepNumber : lowestStepNumber;
      }, currentStep);
      return parseInt(stepNumber, 10);
    }, _this2.updateStepErrorMap = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this$state2, stepErrors, currentStep, fieldsWithErrors, hasErrors, stepErrorMap;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, stepErrors = _this$state2.stepErrors, currentStep = _this$state2.currentStep;
              fieldsWithErrors = _this.getInvalidFieldsForCurrentStep();
              hasErrors = fieldsWithErrors.length;
              stepErrorMap = _extends({}, stepErrors, _defineProperty({}, currentStep, hasErrors ? fieldsWithErrors : null));
              return _context2.abrupt("return", new Promise(function (resolve) {
                _this.setState({
                  stepErrors: stepErrorMap
                }, function () {
                  return resolve(stepErrorMap);
                });
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), _this2.validatePreviousSteps = function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(endStepNumber) {
        var currentStep;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                currentStep = 1;

              case 1:
                if (!(currentStep <= endStepNumber)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 4;
                return _this.previewStep(currentStep++);

              case 4:
                _context3.next = 6;
                return _this.updateStepErrorMap();

              case 6:
                _context3.next = 1;
                break;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), _this2.getKeypathList = function (obj) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (!obj) return list;

      if (typeof obj !== 'string') {
        Object.keys(obj).reduce(function (result, key) {
          var currentPath = path.length ? "".concat(path, ".").concat(key) : key;

          var currentList = _this2.getKeypathList(obj[key], list, currentPath);

          result.concat(currentList);
          return result;
        }, []);
        return list;
      }

      list.push("".concat(path));
      return list;
    }, _this2.previewStep = function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(stepNumber) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve) {
                  return _this.setState({
                    currentStep: stepNumber
                  }, resolve);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }(), _this2.jumpToStep = function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(newStepNumber) {
        var _this$state3, biggestStepReached, stepErrors, dispatchTouch, newStepHasErrors, newBiggestStepReached;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$state3 = _this.state, biggestStepReached = _this$state3.biggestStepReached, stepErrors = _this$state3.stepErrors;
                dispatchTouch = _this.props.dispatchTouch;
                newStepHasErrors = !!stepErrors[newStepNumber];
                newBiggestStepReached = biggestStepReached > newStepNumber ? biggestStepReached : newStepNumber;

                _this.setState({
                  formValidationInProgress: true
                });

                _context5.next = 7;
                return _this.validatePreviousSteps(newBiggestStepReached);

              case 7:
                _this.setState({
                  formValidationInProgress: false
                });

                _this.setState({
                  currentStep: newStepNumber,
                  biggestStepReached: newBiggestStepReached
                }, function () {
                  if (newStepHasErrors) {
                    // touch the fields, that causes validation errors to be shown
                    dispatchTouch.apply(void 0, [FORM_NAME].concat(_toConsumableArray(stepErrors[newStepNumber])));
                  }

                  _this.handleStepSubmit();
                });

                _this.setState({
                  currentStep: newStepNumber,
                  biggestStepReached: biggestStepReached > newStepNumber ? biggestStepReached : newStepNumber
                }, function () {
                  return _this.handleStepSubmit();
                });

                setTimeout(function () {
                  var newStepNumberBtn = document.getElementById("step-title-".concat(newStepNumber));

                  if (newStepNumberBtn) {
                    newStepNumberBtn.scrollIntoView();
                  }
                }, 100);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(), _temp));
  }

  _createClass(BirForm, [{
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          currentStep = _this$state4.currentStep,
          formValidationInProgress = _this$state4.formValidationInProgress,
          stepErrors = _this$state4.stepErrors;
      var _this$props2 = this.props,
          initialValues = _this$props2.initialValues,
          handleChange = _this$props2.handleChange,
          uploadingFiles = _this$props2.uploadingFiles,
          files = _this$props2.files,
          fields = _this$props2.fields,
          filteredFieldsHierarchy = _this$props2.filteredFieldsHierarchy,
          hideSubmitButton = _this$props2.hideSubmitButton,
          country = _this$props2.country,
          language = _this$props2.language;
      var stepHierarchy = filteredFieldsHierarchy.find(function (step) {
        return step.stepNumber === currentStep;
      });
      return React.createElement('div', {
        className: "panel-group ".concat(formValidationInProgress ? 'validation-in-progress' : '')
      }, stepHierarchy && React.createElement(BirFormStep, {
        fields: fields,
        stepData: stepHierarchy,
        stepNum: currentStep || 1,
        initialValues: initialValues,
        totalSteps: this.getTotalSteps(),
        stepsNames: this.getStepTitles(),
        stepErrors: stepErrors,
        handleChange: handleChange,
        jumpToStep: this.jumpToStep,
        onSubmit: this.handleStepSubmit,
        onFinalSubmit: this.handleFinalSubmit,
        lastStep: currentStep === this.getTotalSteps() ? true : false,
        files: files,
        uploadingFiles: uploadingFiles,
        hideSubmitButton: hideSubmitButton,
        country: country,
        language: language
      }));
    }
    /**
     * Check error messages for the current step and update stepErrors map with
     * any messages found for the current step
     * Returns a promise that resolves with new stepErrors map once it's been
     * updated in state object
     */

    /**
     * Go through all the previous steps - render them and collect field error messages
     */

    /**
     * Used to generate list of keypaths for the fields that have reported errors.
     * Redux form reports errors using nested structures of objects and arrays.
     * redux-form field actions usually need a keypath rather than structure (e.g. like "touch" action)
     */

    /**
     * Opens form step for preview/check.
     * Used to render all the form fields of a single step, which makes redux-form re-validate
     * them and update their error messages in the redux store
     * Returns a promise which resolves after render and validation are done
     */

    /**
     * Main method for changing form step
     */

  }]);

  return BirForm;
}(Component);

BirForm.propTypes = {
  fields: PropTypes.array.isRequired,
  fieldsHierarchy: PropTypes.array.isRequired,
  initialValues: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleFinalSubmit: PropTypes.func.isRequired,
  country: PropTypes.string,
  language: PropTypes.string,
  hideSubmitButton: PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state, props) {
  var fieldsHierarchy = props.fieldsHierarchy,
      fields = props.fields;
  var filteredFieldsHierarchy = fieldsHierarchy.filter(function (fieldHierarchy) {
    return fieldHierarchy.sections.some(function (section) {
      var sectionFields = filterFieldsByFieldIds(fields, section.fields);

      var _getSectionConditions = getSectionConditionsInfo(state, sectionFields),
          allFieldsHaveConditions = _getSectionConditions.allFieldsHaveConditions,
          someFieldConditionsFulfilled = _getSectionConditions.someFieldConditionsFulfilled;

      return !allFieldsHaveConditions || someFieldConditionsFulfilled;
    });
  }); // update step numbers

  filteredFieldsHierarchy.forEach(function (fieldHierarchy, index) {
    return fieldHierarchy.stepNumber = index + 1;
  });
  return {
    formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
    formData: getFormValues(FORM_NAME)(state),
    filteredFieldsHierarchy: filteredFieldsHierarchy
  };
};

var mapDispatchToProps = {
  dispatchTouch: touch
};
export default connect(mapStateToProps, mapDispatchToProps)(BirForm);